import React from "react";
var __jsx = React.createElement;
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import { OptionLabel } from './TagAutocompleteOption.style';

var TagAutocompleteOption = function TagAutocompleteOption(_ref) {
  var label = _ref.label,
      _ref$state = _ref.state,
      inputValue = _ref$state.inputValue,
      selected = _ref$state.selected,
      isMultiple = _ref.isMultiple;

  if (selected) {
    return __jsx("span", null, label);
  }

  var matches = match(label, inputValue);
  var parts = parse(label, matches);
  return __jsx("div", null, parts.map(function (part, index) {
    return __jsx(OptionLabel, {
      key: index,
      highlighted: part.highlight,
      multiple: isMultiple
    }, part.text);
  }));
};

export default TagAutocompleteOption;